var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"tab-item",on:{"click":_vm.TabClick}},[_c('div',{class:{ active: _vm.isActive }},[_vm._t("text")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }